import React from "react";
import Input from "../../../UI/Input";

const DialogInput = React.forwardRef((props, ref) => {
    return (
        <Input ref={ref} bottomBorder {...props} />
    );
});

export default DialogInput;